export default class Permissions {
  constructor({ id, name, description, index = 0 }) {
    this.id = id;
    this.name = name;
    this.index = index + 1;
    this.description = description;
  }
}
